<template>
    <div id="pembayaran">
        <ol class="breadcrumb pull-right">
            <li><router-link :to="{ path: '/' }">Home</router-link></li>
            <li>Pembayaran</li>
            <li class="active">Pembayaran User</li>
        </ol>

        <h1 class="page-header">Pembayaran User</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">List Pembayaran User</h4>
                    </div>
                    <div class="panel-body">
                        <app-datatable
                            :items="pembayaranList"
                            :headers="headers"
                            :has-action="false"
                            :has-payment-status="true"
                            :has-custom-search="true"
                            :has-custom-pagination="true"
                            :custom-pagination-current-page="
                                pagination.currentPage
                            "
                            :custom-pagination-per-page="pagination.perPage"
                            :custom-pagination-total-pages="
                                pagination.totalPages
                            "
                            :custom-pagination-sort-mode="pagination.sortMode"
                            v-on:selected="selectedRow = $event"
                            v-on:dblClicked="detailPembayaran()"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                            v-on:changeSortMode="
                                pagination = { ...pagination, sortMode: $event }
                            "
                            v-on:doSearch="
                                search = {
                                    query: $event.value,
                                    by: headersKey[$event.key],
                                }
                            "
                        ></app-datatable>
                    </div>
                </div>
            </div>
        </div>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "list-pembayaran",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            pembayaranList: [],
            isLoading: false,
            selectedRow: null,
            headers: [
                "Order Id",
                "Username",
                "NoTelp",
                "Email",
                "Tipe",
                "Dari Rekening",
                "Ke Rekening",
                "Tanggal Transfer",
            ],
            headersKey: [
                "code",
                "userName",
                "phoneNumber",
                "userEmail",
                "type",
                "bankName",
                "paymentBankName",
                "transferDatetime",
                "status",
            ],
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },

        search: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = this.search;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            this.isLoading = true;

            SalesService.getPembayaranList(pagination, search, (result) => {
                context.pembayaranList = [];
                context.isLoading = false;

                if (result.success) {
                    if (result.data.length > 0) {
                        result.data.forEach((content) => {
                            var row = {
                                id: content.id,
                                data: [
                                    content.code || "-",
                                    content.user_name || "-",
                                    content.phone_number || "-",
                                    content.user_email || "-",
                                    content.type || "-",
                                    content.bank_name || "-",
                                    content.payment_bank_name || "-",
                                    content.transfer_datetime || "-",
                                ],
                                status: [content.status || "-"],
                            };

                            context.pagination.totalPages = content.page;
                            context.pembayaranList.push(row);
                        });
                    }
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },

        detailPembayaran: function () {
            var queryId = this.selectedRow.id;
            this.$router.push({
                path: "/pembayaran/detail",
                query: { id: queryId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Pembayaran.vue?62ccb1e4